<template>
  <div class="pchomex" @scroll="scrollEvent" ref="scrollDiv">
    <!-- <div style="width:1rem;height:192px;background:red">
		</div> -->
    <!-- <div style="font-family: PingFangSC-Regular;">
			abcdefghijklmn
		</div> -->
    <div class="homevideot" v-if="tohomevid">
      <div class="videcont">
        <video :src="homevideotcon" autoplay="autoplay" controls></video>
        <div class="el-icon-circle-close" @click="closevideo"></div>
      </div>
    </div>
    <div class="pchome-header">
      <div class="bannerimg" v-if="pcbanimg.length">
        <!--				<img @load="getimg()" :src="pcbanimg" />-->
        <!-- <img :src="pcbanimg" /> -->
        <carousel :list="pcbanimg">
          <template v-slot:carousel="{index}">
            <div class="product-title-home animate__animated animate__fadeInLeft" v-if="first_product_list[index] && first_product_list[index]['id']">
              <div class="title-model" :style="'color:'+first_product_list_color">{{first_product_list[index]['name']}}</div>
              <div class="title-hea" :style="'color:'+first_product_list_color">{{first_product_list[index]['name_content']}}</div>
              <div class="product-but" @click="natdetailsto(first_product_list[index].id,first_product_list[index].name_content === void 0?1:0)" :style="'background:'+nav_text_color">
                {{redirmore}}
              </div>
            </div>
          </template>
        </carousel>
      </div>
      <headers @ChangeEmit="ChangeEmit"></headers>
      <!-- <scroheader  @ChangeEmit="ChangeEmit"></scroheader> -->
      <!-- <transition  enter-active-class="fadeInLeft"> -->

      <!-- </transition> -->
    </div>
    <div class="pchome-product">
      <div class="big-product" v-for="(item,index) in senpcproductcont" :id="'id'+index">
        <img @click="natdetailsto(item.product_id)" :src="item.second_image" :class="{bigproim:true,bigproimter:item.mess1}" />
        <div class="product-titles" ref="bigprotitle" :class="{bigproim_:true,bigproimter:senpcproductcont_text[index].mess1}">
          <div class="title-models" :style="'color:'+item.second_color">{{item.second_product_list.name}}</div>
          <div class="title-heas" :style="'color:'+item.second_color">{{item.second_product_list.name_content}}</div>
          <div class="product-buts" @click="natdetailsto(item.product_id)" :style="'background:'+nav_text_color">
            {{redirmore}}
          </div>
        </div>
      </div>
      <div class="main-product">
        <div class="main-item" v-for="(item,index) in bigpcproductticont" :id="'minid'+index">
          <div class="main-hea" @click="natdetailsto(item.product_id)" :class="{mainproim_img:true,mianproimter_img:item.mess1}">
            <img :src="item.product_image" />
          </div>
          <div class="main-foo" :class="{mainproim:true,mianproimter:item.mess1}">
            <div class="foo-hea">{{item.product_data_list.name}}</div>
            <div class="foo-title">{{item.product_data_list.name_content}}</div>
            <div class="foo-but" @click="natdetailsto(item.product_id)" :style="'background:'+nav_text_color">{{redirmore}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-carousel class="car-weiper" :autoplay="true" :interval="5000" v-if="false">
      <el-carousel-item v-for="(item,index) in videopcproduct" :key="index" class="carweiper-item">
        <div class="swiper-cont">
          <div class="cont-left">
            <div class="contleft-name">{{item.videos_title}}</div>
            <div class="contleft-article">{{item.videos_mark}}</div>
            <div class="contleft-but" @click="videoto()" :style="'background:'+nav_text_color">{{redirmore}}</div>
          </div>
          <div class="cont-right">
            <div class="contright-video">
              <!--							<video controls :src="item.videos" preload="none" :poster="item.videos_image" ></video>-->
              <img :src="item.videos_image" />
            </div>
            <div class="contright-icon" @click="optionssvid(item.videos)">
              <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pchomeplay.svg" />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="create" ref="testref" v-if="$store.state.lang == 'cn'">
      <div class="create-hea">
        {{created}}
      </div>
      <div class="create-foo">
        <!-- <div class="createfootop">
					<div class="crefoo-item">
						<div class="crefooitem-left">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pcdompaten.svg" />
						</div>
						<div class="crefooitem-right">
							<div class="crefooitem-rightheader">
								{{bird_created[0].max_title}}<span :style="'color:'+nav_text_color">{{oldValue}}</span>{{pometerm}}
							</div>
							<div class="crefooitem-rightfoo"  >
								{{bird_created[0].min_title}}<span :style="'color:'+nav_text_color">{{fotoldValue}}</span>{{pometerm}}
							</div>
						</div>
					</div>
					<div class="crefoo-item">
						<div class="crefooitem-left">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pcintermon.svg" />
						</div>
						<div class="crefooitem-right">
							<div class="crefooitem-rightheader">
								{{bird_created[1].max_title}}<span :style="'color:'+nav_text_color">{{leftoldValue}}</span>{{pometerm}}
							</div>
							<div class="crefooitem-rightfoo">
								{{bird_created[1].min_title}}<span :style="'color:'+nav_text_color">{{leftfotoldValue}}</span>{{pometerm}}
							</div>
						</div>
					</div>
				</div> -->
        <div class="createfootop">
          <div class="crefoo-item">
            <div class="crefooitem-left">
              <img src="../../assets/pchomeimg/pchomeadon.svg" />
            </div>
            <div class="crefooitem-right">
              <div class="crefooitem-rightheader">
                {{bird_created[2].max_title}}<span :style="'color:'+nav_text_color">{{tacoldValue}}</span
                >{{pometerm}}
              </div>
              <div class="crefooitem-rightfoo">
                {{bird_created[2].min_title}}<span :style="'color:'+nav_text_color">{{fottacoldValue}}</span
                >{{pometerm}}
              </div>
            </div>
          </div>
          <div class="crefoo-item">
            <div class="crefooitem-left">
              <img src="../../assets/pchomeimg/pchomeain.svg" />
            </div>
            <div class="crefooitem-right">
              <div class="crefooitem-rightheader">
                {{bird_created[3].max_title}}<span :style="'color:'+nav_text_color">{{gighfotoldValue}}</span
                >{{pometerm}}
              </div>
              <div class="crefooitem-rightfoo">
                {{bird_created[3].min_title}}<span :style="'color:'+nav_text_color">{{fotgighfotoldValue}}</span
                >{{pometerm}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="create" ref="testref" v-if="$store.state.lang == 'en'">
      <div class="create-hea">
        {{created}}
      </div>
      <div class="create-foo">
        <!-- <div class="createfootop"> -->
        <!-- <div class="crefoo-item">
						<div class="crefooitem-left">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pcdompaten.svg" />
						</div>
						<div class="crefooitem-right">
							<div class="crefooitem-rightheader">
								<span :style="'color:'+nav_text_color">{{oldValue}}&nbsp</span>{{bird_created[0].max_title}}{{pometerm}}
							</div>
							<div class="crefooitem-rightfoo"  >
								<span :style="'color:'+nav_text_color">{{fotoldValue}}&nbsp</span>{{bird_created[0].min_title}}{{pometerm}}
							</div>
						</div>
					</div>
					<div class="crefoo-item">
						<div class="crefooitem-left">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pcintermon.svg" />
						</div>
						<div class="crefooitem-right">
							<div class="crefooitem-rightheader">
								<span :style="'color:'+nav_text_color">{{leftoldValue}}&nbsp</span>{{bird_created[1].max_title}}{{pometerm}}
							</div>
							<div class="crefooitem-rightfoo">
								<span :style="'color:'+nav_text_color">{{leftfotoldValue}}&nbsp</span>{{bird_created[1].min_title}}{{pometerm}}
							</div>
						</div>
					</div>
				</div> -->
        <div class="createfootop">
          <div class="crefoo-item">
            <div class="crefooitem-left">
              <img src="../../assets/pchomeimg/pchomeadon.svg" />
            </div>
            <div class="crefooitem-right">
              <div class="crefooitem-rightheader">
                <span class="theme--color" :class="$store.state.brand">{{tacoldValue}}&nbsp</span>{{bird_created[2].max_title}}{{pometerm}}
              </div>
              <div class="crefooitem-rightfoo">
                <span class="theme--color" :class="$store.state.brand">{{fottacoldValue}}&nbsp</span>{{bird_created[2].min_title}}{{pometerm}}
              </div>
            </div>
          </div>
          <div class="crefoo-item">
            <div class="crefooitem-left">
              <img src="../../assets/pchomeimg/pchomeain.svg" />
            </div>
            <div class="crefooitem-right">
              <div class="crefooitem-rightheader">
                <span class="theme--color" :class="$store.state.brand">{{gighfotoldValue}}&nbsp</span>{{bird_created[3].max_title}}{{pometerm}}
              </div>
              <div class="crefooitem-rightfoo">
                <span class="theme--color" :class="$store.state.brand">{{fotgighfotoldValue}}&nbsp</span>{{bird_created[3].min_title}}{{pometerm}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pcho-query">
      <div class="pcho-queryhea">{{anti.title}}</div>
      <div class="pcho-querycent">{{anti.describe}}</div>
      <div class="pcho-queryinput">
        <input v-model="quersu" :placeholder="anti.tips" />
        <div class="inpt-but" @click="oponzmnqu" :style="'background:'+nav_text_color">{{anti.btn}}</div>
      </div>
    </div>
    <div class="more-support">
      <div class="more-supporthea">
        {{more.title}}
      </div>
      <div class="more-supportfoo">
        <div class="more-map" @click="contactusto()">
          <img src="../../assets/pchomeimg/pchomemap.svg" />
          {{more.map}}
        </div>
        <div class="more-map" @click="queryto()">
          <img src="../../assets/pchomeimg/pchomeservice.svg" />
          {{more.user}}
        </div>
        <div class="more-map" @click="contactusto()">
          <img src="../../assets/pchomeimg/pccontactus.svg" />
          {{more.contact}}
        </div>
      </div>
    </div>
    <!--ref="is_change"是子组件在父组件中的名字-->
    <footers ref="is_change"></footers>
  </div>
</template>

<script>
// import {refreshRem} from 'lib-flexible/flexible.js'
import {session} from '../../storage/storage.js';
import headers from '../../common/header.vue'
import scroheader from '../../common/scroheader.vue'
import footers from '../../common/footers.vue'
export default{
	data(){
		return{
			nav_text_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'',
			id:'',
			tohomevid:false,
			navheader:false,
			heshow:false,
			show: false,
			playli:true,
			playri:true,
			testShow:false,
			testShowbig:false,
			lang:'',
			pometerm:'项',
			quersu:'',
			oldValue:0,
			fotoldValue:0,
			leftoldValue:0,
			leftfotoldValue:0,
			first_product_list_color:'',
			tacoldValue:0,
			fottacoldValue:0,
			gighfotoldValue:0,
			fotgighfotoldValue:0,
			pcbanimg:[],
			bigpcproductti:'',
			senpcproduct:[],
			senpcproductcont:[],
			senpcproductcont_text:[],
			bigpcproductticont:[],
			videopcproduct:'',
			first_product_list:[],
			is_change: 0,
			bannproid:'',
			created:"啄木鸟创造",
			redirmore:'了解更多',
			created_data:{},
			bird_created:[
				{'max_title':'已申请国内专利521','min_title':'其中发明专利122'},
				{'max_title':'已申请国际专利13','min_title':'其中发明授权专利11'},
				{'max_title':'已获授权国内专利254','min_title':'其中发明授权专利19'},
				{'max_title':'已获授权国际专利4','min_title':'其中发明授权专利2'},
			],
			anti:{
				title:"防伪查询",
				describe:"为了方便广大用户查询,我司于近期升级了防伪查询系统",
				tips:"请输入防伪码",
				btn:"提交"
			},
			more:{
				title:"获取更多支持",
				map:"地图定位",
				user:"用户服务",
				contact:"联系我们"
			}
		}
	},
	components:{
		headers,
		scroheader,
		footers
	},
	watch:{
		'$route': 'getParams',
	},
	beforeCreate(){
		// refreshRem()
		// document.documentElement.style.fontSize = '192px'
	},
	mounted() {
		var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		sessionStorage.setItem('page',JSON.stringify({name:'pchome',data:false}))
		window.addEventListener("scroll", this.handleScroll)
		this.$once('hook:beforeDestroy', () => {
			document.removeEventListener('scroll', this.handleScroll,false)
		})
		// if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
		// 	console.log('手机手机21321321')
    //
		// 	this.$router.push({path:'./phhome',query:{e:this.$route.query.e}})
		// }
	},
	methods: {
		natdetailsto(e,is_news){
			if(is_news === 1){
				this.$router.push({path: '/pcnewdetail',query:{e,type:'pc'}})
			}else{
				this.$router.push({path: '/pcdetails',query:{e,type:'pc'}})
			}
		},
		scrollEvent () {
			/* bigprotitle */
			/* console.log(this.$refs.scrollDiv.scrollTop) */
			if(this.$refs.scrollDiv.scrollTop!==0){
				this.navheader=true
			}
		},
		closevideo(){
			this.tohomevid=false
		},
		optionssvid(e){
			this.tohomevid=true
			this.homevideotcon=e
		},
		ChangeEmit(){ //子组件传递
			//主动调用子组件
			this.$refs.is_change.get_index_channel_data();
			this.$refs.is_change.pageParam();
			this.getParams()
			this.heshow=true
			this.pchomeprod()
			this.pageParam() //页面静态参数
			// this.nav_text_color = session.get('channel_id')==1?'#c32329':session.get('channel_id')==2?'#304895':'#313131'
		},
		pageParam(){
			let lang =  session.get("lang");
			if (lang === "cn"){
				this.created = "啄木鸟创造"
				this.redirmore='了解更多'
				this.pometerm='项'
				this.bird_created =  [
					{'max_title':'已申请国内专利','min_title':'其中发明专利'},
					{'max_title':'已申请国际专利','min_title':'其中发明授权专利'},
					{'max_title':'已获授权国内专利','min_title':'其中发明授权专利'},
					{'max_title':'已获授权国际专利','min_title':'其中发明授权专利'},
				]
				this.anti = {
					title:"防伪查询",
					describe:"为了方便广大用户查询,我司于近期升级了防伪查询系统",
					tips:"请输入防伪码",
					btn:"提交"
				}
				this.more = {
					title:"获取更多支持",
					map:"地图定位",
					user:"用户服务",
					contact:"联系我们"
				}
			}else{
				this.created = "CREATION OF WOODPECKER"
				this.redirmore='Learn more'
				this.pometerm=''
				this.bird_created =  [
					{'max_title':'Chinese patents applied for','min_title':'invention patents included'},
					{'max_title':'international patents applied for','min_title':' invention patents included'},
					{'max_title':'authorized Chinese patents','min_title':'invention patents included'},
					{'max_title':'authorized international patents','min_title':'invention patents included'},
				]

				this.anti = {
					title:"ANTI-FAKE INQUIRY",
					describe:"For accessible checking, our anti-fake inquiry system is newly updated.",
					tips:"Please input anti-fake code",
					btn:"submit"
				}

				this.more = {
					title:"MORE SUPPORT",
					map:"Map",
					user:"User Service",
					contact:"Contact Us"
				}
			}
		},
		pchomeprod(){
			let data = {
				mold: "pc",
				lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
				channel_id:  session.get("channel_id") == '' ? 1 : session.get("channel_id"),
			}
			this.$api.goFeedback(data).then((res) => {
					this.pcbanimg=res.data.first_image?res.data.first_image.split(','):[]
					this.bigpcproductti=res.data.product_data
					this.bigpcproductticont=[]
					this.bigpcproductti.map(((item, index)=> {
						this.bigpcproductticont.push(Object.assign({},item,{mess1:false,mess2:8}))
					}))
					this.created_data = res.data.created
					// console.log(this.created_data)
					this.senpcproduct=res.data.second_data
					this.senpcproductcont=[]
					this.senpcproduct.map(((item, index)=> {
						this.senpcproductcont.push(Object.assign({},item,{mess1:false,mess2:8}))
						this.senpcproductcont_text.push(Object.assign({},item,{mess1:false,mess2:8}))
					}))
					// for(let index=0;index<this.videopcproduct.length;index++){
					// 	this.videopcproduct[index].videos_image = require(this.videopcproduct[index].videos_image)
					// }
					this.videopcproduct=res.data.videos_data
					// console.log('res.data.videos_data',res.data.videos_data)
					this.first_product_list = res.data.first_product_list
					this.first_product_list_color = res.data.first_color
					this.bannproid=res.data.first_product_id
					this.nav_text_color=session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
					this.$nextTick(() => {
					    setTimeout(() => {
							// const doms = document.getElementsByClassName('product-title-home');
							// for(let i=0,len=doms.length;i<len;i++){
							// 	doms[i].style['margin-left'] = '240px'
							// 	doms[i].style['opacity'] = '1'
							// }
						}, 800);
					})

			});
		},
		oponzmnqu(){
			/* let af=23682052 */
			let af=this.quersu
			/* window.location.href = 'URL'; */
			window.location.href="http://cx.glwoodpecker.com.cn:88/Wp/gl?af="+af;
		},
		handleScroll () {

		var domHight = document.body.offsetHeight;
		// dom滚动位置
		var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

		// 获取监听元素
		var id;
		// 获取监听元素本身高度
		var scrollHeight;
		// 获取监听元素距离视窗顶部距离
		var offsetTop;
		// 获取监听元素距离顶部高度-窗口高度
		for(let i=0;i<this.senpcproductcont.length;i++){
			id = document.getElementById(`id${i}`);
			if(id != null){
				scrollHeight = id.scrollHeight;
				var offsetTop = id.offsetTop;
				// 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
				if (scroll > offsetTop -800) {i
					this.senpcproductcont[i].mess1=true
					setTimeout(() => {
						this.senpcproductcont_text[i].mess1=true
					}, 400);i
				}
			}
		}
		for(let i=0;i<this.bigpcproductticont.length;i++){
			id = document.getElementById(`minid${i}`);
			if(id != null){
				let  mianscrollHeight = id.scrollHeight;
				var mianoffsetTop = id.offsetTop;
				if (scroll > mianoffsetTop  - 600) {
					this.bigpcproductticont[i].mess1=true
				}
			}
		}

           let currentScroll = window.pageYOffset //表示当前滚动的位置
			 if(this.$refs.testref != undefined){
				 if (currentScroll >= this.$refs.testref.offsetTop - 600) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
					 this.testShow = true;
					 let that = this;
					 let timer = setInterval(function() {
						 if (that.oldValue < that.created_data.apply_inner_num) {
							 that.oldValue++;
						 } else {
							 clearInterval(timer);
						 }
					 }, 15);
					 let fottimer = setInterval(function() {
						 if (that.fotoldValue < that.created_data.apply_inner_num_fa) {
							 that.fotoldValue++;
						 } else {
							 clearInterval(fottimer);
						 }
					 }, 60);
					 let lefttimer = setInterval(function() {
						 if (that.leftoldValue < that.created_data.apply_out_num) {
							 that.leftoldValue++;
						 } else {
							 clearInterval(lefttimer);
						 }
					 }, 265);
					 let leffotttimer = setInterval(function() {
						 if (that.leftfotoldValue < that.created_data.apply_out_num_fa) {
							 that.leftfotoldValue++;
						 } else {
							 clearInterval(leffotttimer);
						 }
					 }, 260);
					 let tactimer = setInterval(function() {
						 if (that.tacoldValue < that.created_data.get_inner_num) {
							 that.tacoldValue++;
						 } else {
							 clearInterval(tactimer);
						 }
					 }, 20);
					 let fottactimer = setInterval(function() {
						 if (that.fottacoldValue < that.created_data.get_inner_num_fa) {
							 that.fottacoldValue++;
						 } else {
							 clearInterval(fottactimer);
						 }
					 }, 265);
					 let righfotttimer = setInterval(function() {
						 if (that.gighfotoldValue < that.created_data.get_out_num) {
							 that.gighfotoldValue++;
						 } else {
							 clearInterval(righfotttimer);
						 }
					 }, 260);
					 let fotrighfotttime = setInterval(function() {
						 if (that.fotgighfotoldValue < that.created_data.get_out_num_fa) {
							 that.fotgighfotoldValue++;
						 } else {
							 clearInterval(fotrighfotttime);
						 }
					 }, 260);
					 // console.log('testref到了')
				 }
			 }
			// if (currentScroll >= this.$refs.bigprotitle.offsetTop + 600 ) { //当前滚动位置到达bigprotitle的时候，显示div（100作为调整用）
			// 	this.testShowbig=true
			//     }
		    var scrollTop =  document.documentElement.scrollTop || document.body.scrollTop

			if(scrollTop!==0){
				this.navheader= true;
			}
		},
		hometo(){
			this.$router.push({path: '/pchome'})
		},
		videoto(){
			this.$router.push({path: '/pcvideos'})
		},
		queryto(){
			this.$router.push({path: '/pcquerys'})
		},
		productto(){
			this.$router.push({path: '/pcproduct'})
		},
		elitesto(){
			this.$router.push({path: '/pcelites'})
		},
		contactusto(){
			this.$router.push({path: '/pccontactus'})
		},
		aboutto(){
			this.$router.push({path: '/pcabout'})
		},
		seachto(){
			this.$router.push({path: '/pcseachs'})
		},
		nextimg(){
			let l = this.list_img.length;
			let scroll = document.getElementById('scroll-x');
			let diatance = scroll.scrollWidth - scroll.clientWidth;
			if(this.current_index == 0){
				this.current_index = l-1;
				scroll.scrollLeft = diatance;
			}else{
				this.current_index--;
				scroll.scrollLeft -= diatance / (l - 1);
			}
		},
		preimg(){
			let l = this.list_img.length;
			let scroll = document.getElementById('scroll-x');
			let diatance = scroll.scrollWidth - scroll.clientWidth;
			if(this.current_index+1 == l){
				this.current_index = 0;
				scroll.scrollLeft = 0;
			}else{
				this.current_index++;
				scroll.scrollLeft += diatance / (l - 1);
			}
		},
		enter(index){
		  this.navheader= true;
		},
		playenterli(){
			this.playli=false
		},

		playenterri(){
			this.playri=false
		},
		playleaveli(){
			this.playli=true
		},
		playleaveri(){
			this.playri=true
		},
	  getParams () {
			this.id = this.$route.query.e
		}

	 }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
.pchomex .pcindedxc{
	width: calc(100vw - 50px);
	height: calc(100vh - 50px);
	position: relative;
	background: #FAFAFA;
}
.pchomex .pchome-header{
	width: 100%;
	height:960px;
	position: relative;
	background-size: 100% 100%;
	padding-top: 319px;
	box-sizing: border-box;
}
.pchomex .bannerimg{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 960px;
}
.pchomex .bannerimg img{
	width: 100%;
	height: 100%;
}

.pchomex .checse{
	margin-top: 0 !important;
}
.product-title-home{
  color: #fff;
  margin-top: 0;
  left: 260px;
  //opacity: 0;
  top: 320px;
  position: absolute;
}

@keyframes moveRight {
  from {
    left: -260px;
    opacity: 0;
  }
  to {
    left: 260px;
    opacity: 1;
  }
}
.pchomex .bannerimgs{

}
.pchomex .title-hea{
	font-size: 20px;
	font-weight: normal;
	letter-spacing: 1px;
}
.pchomex .title-model{
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 38px;
	font-weight: normal;
	letter-spacing: 2px;
}
.pchomex .product-but{
	margin-top: 40px;
	font-size: 16px;
	width: 110px;
	height: 46px;
	background: #E31E24;
	border-radius: 23px;
	line-height: 46px;
	text-align: center;
	cursor: pointer;
	font-size: 16px;
}


.pchomex .pchome-product{
	/* margin-top: ; */
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-direction: column;
	width: 100%;
	/* height: 100%; */
}
.pchomex .big-product{
	width: 1440px;
	height: 680px;
	overflow: hidden;
	position: relative;
	margin-top: 80px;
	border-radius: 20px;
}
.pchomex .big-product:hover img{
	cursor: pointer;
	width: 1440px;
	height: 680px;
	transform: scale(1.02,1.02);
}
.pchomex .big-product img{
	width: 1440px;
	height: 680px;
	border-radius: 20px;
	transition: all .75s linear;
}
.pchomex .product-titles{
	color: #5d5f5f;
	top: 178px;
	left: 152px;
	position: absolute;
}
.pchomex .title-heas{
	font-size: 20px;
	font-weight: normal;
	letter-spacing: 1px;
}
.pchomex .title-models{
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 44px;
	font-weight: normal;
	letter-spacing: 2px;
}
.pchomex .product-buts{
	color: #fff;
	margin-top: 40px;
	font-size: 16px;
	width: 110px;
	height: 46px;
	background: #E31E24;
	border-radius: 23px;
	line-height: 46px;
	text-align: center;
	cursor: pointer;
	font-size: 16px;
}
.pchomex .main-item{
	margin-bottom: 40px;
}
.pchomex .main-item:nth-child(2n){
	margin-left: 40px;
}
.pchomex .main-product{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	width: 100%;
	/* height: 100%; */
	margin-top: 80px;
}
.pchomex .main-hea{
	width: 700px;
	height: 520px;
	border-radius: 20px 20px 0px 0px;
	overflow: hidden;
}
.pchomex .main-hea:hover img{
	cursor: pointer;
	width: 700px;
	height: 520px;
	transform: scale(1.02,1.02);
}
.pchomex .main-hea img{
	border-radius: 20px 20px 0px 0px;
	width: 700px;
	height: 520px;
	transition: all .75s linear;
}
.pchomex .main-foo {
	width: 700px;
	height: 250px;
	background: #FFFFFF;
	border-radius: 0px 0px 20px 20px;
	padding-top: 40px;
	box-sizing: border-box;
	padding-left: 40px;

}
.pchomex .foo-hea{

	height: 45px;
	font-size: 32px;
	font-weight: 600;
	color: #5d5f5f;
	line-height: 45px;
	letter-spacing: 1px;
}
.pchomex .foo-title{
	margin-top: 10px;
	height: 22px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
	line-height: 22px;
}
.pchomex .foo-but{
	color: #fff;
	margin-top: 20px;
	width: 110px;
	height: 46px;
	background: #E31E24;
	border-radius: 23px;
	line-height: 46px;
	text-align: center;
	cursor: pointer;
	font-size: 16px;
}
.pchomex .is-active{
	/* background-color: rgb(25, 0, 255); */
}
.pchomex .el-carousel__indicator.is-active button{
	/* background-color: rgb(25, 0, 255); */
}
.pchomex .el-carousel__indicator{

}
.pchomex .el-carousel__button{
	width: 12px;
	height: 6px;
	background: #EAEAEA;
	border-radius: 6px;
}
.pchomex .car-weiper{
	height: 559px;
	margin-top: 40px;
	background: #FFFFFF;
}
.pchomex .carweiper-item{
	height: 559px;
	background: #FFFFFF;
}
.pchomex .car-weiper .el-carousel__container{
	height: 559px;
}
.pchomex .swiper-cont{
	display: flex;
	height: 559px;

}
.pchomex .cont-left{
	padding-left: 240px;
	padding-top: 97px;
	box-sizing: border-box;
}
.pchomex .contleft-name{
	width: 558px;
	font-size: 48px;
	font-weight: 600;
	color: #5d5f5f;
	line-height: 67px;
	letter-spacing: 2px;
	white-space: pre-wrap;
}
.pchomex .contleft-article{
	margin-top: 25px;
	width: 558px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
	line-height: 32px;
	white-space: pre-wrap;
}
.pchomex .contleft-but{
	color: #fff;
	margin-top: 40px;
	width: 110px;
	height: 46px;
	background: #E31E24;
	border-radius: 23px;
	line-height: 46px;
	text-align: center;
	cursor: pointer;
	font-size: 16px;
}
.pchomex .cont-right{
	width: 699px;
	height: 393px;
	position: relative;
	margin-top: 80px;
	margin-left: 183px;
}
.pchomex .contright-video{
	width: 699px;
	height: 393px;
}
.pchomex .contright-video img{
	width: 100%;
	border-radius: 10px;
}
.pchomex .contright-video video{
	width: 699px;
	height: 393px;
	border-radius: 10px;
}
.pchomex .contright-icon{
	position: absolute;
	width: 90px;
	height: 90px;
	/*top: 150px;*/
	/*left: 330px;*/
	cursor: pointer;
	display: flex;
	left: 50%;
	top: 50%;
	margin: -45px 0 0 -45px;
}
.pchomex .contright-icon img{
	width: 90px;
	height: 90px;
}
.pchomex .create{
	margin-top: 80px;
	height: 568px;
	background: #FFFFFF;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding-top: 80px;
	box-sizing: border-box;
}
.pchomex .create-hea{
	height: 56px;
	font-size: 40px;
	font-weight: 600;
	color: #5d5f5f;
	line-height: 56px;
	letter-spacing: 2px;
	margin-bottom: 84px;
}
.pchomex .create-foo{
	margin-bottom: 80px;
}
.pchomex .crefoo-item{

	width: 750px;
	display: flex;
	align-items: center;
	justify-content: center;

	/*margin-bottom: 80px;*/
}
.pchomex .crefoo-item span{
	color: #E31E24;
}
.pchomex .crefoo-item:nth-child(2n){
	/*margin-left: 200px;*/
}
.pchomex .crefooitem-left{
	width: 90px;
	height: 90px;
	margin-right: 20px;
	display: flex;
}
.pchomex .crefooitem-left img{
	width: 100%;
	height: 100%;
}
.pchomex .crefooitem-right{

}
.pchomex .crefooitem-rightheader{

	font-size: 28px;
	font-weight: 400;
	color: #5d5f5f;

	letter-spacing: 1px;
	margin-bottom: 20px;
}
.pchomex .crefooitem-rightfoo{

	font-size: 20px;
	font-weight: 400;
	color: #666666;

	letter-spacing: 1px;
}
.pchomex .pcho-query{
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	margin-top: 80px;
}
.pchomex .pcho-queryhea{
	height: 56px;
	font-size: 40px;
	font-weight: 600;
	color: #5d5f5f;
	line-height: 56px;
	letter-spacing: 2px;
}
.pchomex .pcho-querycent{
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	letter-spacing: 1px;
	margin-top: 20px;
}
.pchomex .pcho-queryinput{
	width: 700px;
	height: 60px;
	background: #FFFFFF;
	border-radius: 30px;
	border: 1px solid #CCCCCC;
	display: flex;
	align-items: center;
	margin-top: 40px;
}
.pchomex .pcho-queryinput input{
	width: 500px;
	height: 55px;
	border: none;
	border-radius: 30px;
	margin-left: 15px;
	outline: none;
	font-size: 20px;
	color: #5d5f5f;
}
.pchomex .inpt-but{
	margin-left: 65px;
	color: #fff;
	width: 110px;
	height: 46px;
	background: #E31E24;
	border-radius: 23px;
	line-height: 46px;
	text-align: center;
	cursor: pointer;
	font-size: 16px;
}
input::-webkit-input-placeholder{   /* 使用webkit内核的浏览器 */
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 28px;
	letter-spacing: 1px;
}
input:-moz-placeholder{    /* Firefox版本4-18 */
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 28px;
	letter-spacing: 1px;
}
input::-moz-placeholder{    /* Firefox版本19+ */
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 28px;
	letter-spacing: 1px;
}
input:-ms-input-placeholder{   /* IE浏览器 */
	height: 28px;
	font-size: 20px;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 28px;
	letter-spacing: 1px;
}
.pchomex .more-support{
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-top: 80px;
	margin-bottom: 80px;
}
.pchomex .more-supporthea{
	height: 56px;
	font-size: 40px;
	font-weight: 600;
	color: #5d5f5f;
	line-height: 56px;
	letter-spacing: 2px;
	margin-bottom: 40px;
}
.pchomex .more-supportfoo{
	display: flex;
}
.pchomex .more-map{
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	font-weight: 500;
	color: #5d5f5f;
	letter-spacing: 1px;
	margin-left: 160px;
	cursor: pointer;
}
.pchomex .more-map:first-child{
	margin-left: 0px;
}
.pchomex .more-map img{
	width: 50px;
	height: 50px;
	margin-right: 20px;
}
.pchomex .aboutitem-hea{
	margin-top: 80px;
	margin-bottom: 40px;
	height: 33px;
	font-size: 24px;
	font-weight: 500;
	color: #FFFFFF;
	line-height: 33px;
	letter-spacing: 1px;
}
.pchomex .aboutitem-fooitem{
	margin-bottom: 10px;
}
.pchomex .fooitem-left{
	width: 110px;
	height: 32px;
	border-radius: 4px;
	border: 1px solid #EAEAEA;
	display: flex;
	align-items: center;
	justify-content: center;


	font-size: 16px;
	font-weight: 400;
	color: #FAFAFA;
	margin-right: 20px;
}
.pchomex .fooitem-left img{
	width: 16px;
	height: 16px;
	margin-right: 6px;
}
.pchomex .aboutitem-foosus{
	display: flex;
	margin-bottom: 20px;
}
.pchomex .fooitem-right{
	font-size: 16px;
	font-weight: 400;
	color: #CCCCCC;
}
.pchomex .fooitem-cont{
	margin-top: 25px;
	margin-left: 40px;
}
.pchomex .fooitem-cont:first-child{
	margin-left: 0px;
}
.pchomex .fooite-img{
	display: flex;
}
.pchomex .fooite-img img{
	width: 90px;
	height: 90px;
}
.pchomex .fooite-nam{
	text-align: center;
	margin-top: 20px;
}
.pchomex .right-tit{
	margin-bottom: 5px;
}
.pchomex .homefoot{
	height: 94px;
	background: #272727;
	border-top: 2px solid #666;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.pchomex .foot-hea{
	height: 22px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
	line-height: 22px;
}
.pchomex .foot-f{
	height: 22px;
	font-size: 16px;
	font-weight: 400;
	color: #666666;
	line-height: 22px;
	margin-top: 10px;
	margin-bottom: 20px;
}

.pchomex .bb{
	background-color: #fff;
	position: fixed;
	top: 0;
	z-index: 99;
}
.pchomex .checse{
	-webkit-animation-name: "fadeInLeft"; /*动画名称，需要跟@keyframes定义的名称一致*/
	-webkit-animation-duration: 0.5s;/*动画持续的时间长*/
	-webkit-animation-iteration-count: 1;/*动画循环播放的次数为1 infinite为无限次*/
	position: absolute;
}

.pchomex .testenter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all .5s ease;
}
.pchomex .test{
	transform: translateY(10%);
	opacity: 0;
}
.pchomex .bigproimter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 1s ease;
}
.pchomex .bigproim{
	transform: translateY(20%);
	opacity: 0;
}
.pchomex .bigproim_{
	transform: translateY(40%);
	opacity: 0;
}
.pchomex .mianproimter{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 0.75s ease;
}
.pchomex .mainproim{
	transform: translateY(40%);
	opacity: 0;
}
.pchomex .mianproimter_img{
	transform: translateY(0%) !important;
	opacity: 1 !important;
	transition: all 0.75s ease;
}
.pchomex .mainproim_img{
	transform: translateY(40%);
	opacity: 0;
}
.pchomex .homevideot{
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.32);
    position: fixed;
    top: 0px;
    z-index: 1000;
    display: flex;
	align-items: center;
	justify-content: center;
}
.pchomex .videcont{
	position: relative;
	width: calc(1920px * 0.6);
	height: calc(1080px * 0.6);
}
.pchomex .videcont video{
	width: calc(1920px * 0.6);
	height: calc(1080px * 0.6);
}
.pchomex .el-icon-circle-close{
	font-size: 40px;
	color: #fff;
	position: absolute;
	top: -20px;
	right: -16px;
	cursor: pointer;
}
.pchomex .createfootop{
	display: flex;
	align-items: center;
	justify-content: center;
}
/* .header-nav{
	width: 1400px;
	height: 79px;
	display: flex;
	align-items: center;
	padding: 0 260px;
	position: fixed;
	top: 0;
} */
.pchomex .nav-wit{

}
.pchomex .nav-left{
	width: 100px;
	height: 50px;
}
.pchomex .nav-left img{
	width: 100%;
	height: 100%;
}
/* .nav-center-item:hover{
	border-bottom: 2px solid #E31E24;
} */

.pchomex .nav-center-item:first-child{
	margin-left: 0;
}
.pchomex .nav-right{
	display: flex;
	align-items: center;
	color: #fff;
	font-size: 16px;
	font-weight: 400;
	margin-left: 180px;
}
.pchomex .nav-right .search{
	display: flex;
	align-items: center;
	width: 20px;
	height: 20px;
	margin-right: 20px;
	cursor: pointer;
}
.pchomex .nav-right .search img{
	width: 100%;
	height: 100%;
}
.pchomex .nav-right .homename{
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 20px;
	cursor: pointer;
}
.pchomex .nav-right .homename img{
	width: 16px;
	height: 16px;
	margin-left: 4px;
}
.pchomex .nav-right .language{
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.pchomex .nav-right .language img{
	width: 16px;
	height: 16px;
	margin-left: 6px;
}
</style>
